export default {
  methods: {
    getLocalizedName(item, field = 'name') {
      const locale = this.$store.state.locale;
      const fieldName = `${field}_${locale}`;
      
      // Try to get the field in the current locale
      if (item[fieldName] && item[fieldName].trim() !== '') {
        return item[fieldName];
      }
      
      // Fallback to English if Japanese is not available
      if (locale === 'jp' && item[`${field}_en`] && item[`${field}_en`].trim() !== '') {
        return item[`${field}_en`];
      }
      
      // Fallback to Chinese if English is not available
      if (item[`${field}_zh`] && item[`${field}_zh`].trim() !== '') {
        return item[`${field}_zh`];
      }
      
      // Final fallback to the base field name
      return item[field] || '';
    }
  }
}
